// src/common/components/DialogComponent.js

import React from "react";
import PTDialog from "./PTDialog";

export const PTDialogAppComponent = ({
  open,
  content,
  onConfirm,
  onCancel,
  onClose,
}) => {
  const {title, description, dialogStyle, descriptionStyle, data, ...rest} = content;
  return (
    <PTDialog
      open={open}
      title={content.title}
      description={content.description}
      cancelBtn={content.cancelBtn || "cancel"}
      onConfirm={onConfirm}
      onCancel={onCancel}
      onClose={onClose}
      dialogStyle={content.dialogStyle}
      descriptionStyle={content.descriptionStyle}
      titleStyle={content.titleStyle}
      dialogData={data}
      {...rest}
    />
  );
};

export default PTDialogAppComponent;
